<component is="router-link" :to="{ name: sref, params: parameter, query: options }" :target="target" v-bind="extraAttributes"><slot></slot></component>